// extracted by mini-css-extract-plugin
export default {"container":"right-side-module__container___QoVHu","wrapper":"right-side-module__wrapper___ErIGv"};